import React, { useState, useRef, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { RotateCw } from "lucide-react";

const PULL_THRESHOLD = 100;

export default function PullToRefresh({ onRefresh }) {
  const [pullDistance, setPullDistance] = useState(0);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const touchStartY = useRef(0);
  const scrollStartY = useRef(0);

  const handleTouchStart = (e) => {
    scrollStartY.current = window.scrollY;
    touchStartY.current = e.touches[0].clientY;
  };

  const handleTouchMove = (e) => {
    if (window.scrollY > 0) {
      setPullDistance(0);
      return;
    }

    const touchCurrentY = e.touches[0].clientY;
    const distance = Math.max(0, touchCurrentY - touchStartY.current);
    setPullDistance(distance * 0.5); // Dampen the pull distance
  };

  const handleTouchEnd = async () => {
    if (pullDistance > PULL_THRESHOLD && !isRefreshing) {
      setIsRefreshing(true);
      await onRefresh();
      setIsRefreshing(false);
      setPullDistance(0);
    } else {
      setPullDistance(0);
    }
  };

  useEffect(() => {
    document.addEventListener("touchstart", handleTouchStart);
    document.addEventListener("touchmove", handleTouchMove);
    document.addEventListener("touchend", handleTouchEnd);

    return () => {
      document.removeEventListener("touchstart", handleTouchStart);
      document.removeEventListener("touchmove", handleTouchMove);
      document.removeEventListener("touchend", handleTouchEnd);
    };
  }, [pullDistance, isRefreshing]);

  return (
    <AnimatePresence>
      {(pullDistance > 0 || isRefreshing) && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed top-20 left-1/2 z-40 -translate-x-1/2"
        >
          <motion.div
            animate={{
              rotate: isRefreshing ? 360 : (pullDistance / PULL_THRESHOLD) * 180,
            }}
            transition={{ type: "spring", stiffness: 200, damping: 20 }}
            className="flex items-center justify-center"
          >
            <RotateCw className="w-5 h-5 text-primary" />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}